module.exports = __webpack_public_path__ + "img/missions-and-tasks.67844a42.png";